export default {
  path: 'payments',
  name: 'payments',
  component: () => import('../views/payments/Payments.vue'),
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'payments',
      linkText: 'Платежи и акты'
    }
  }
}